import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  emojiIconClickAwayContainer: {
    position: 'relative',

    '& em-emoji-picker': {
      position: 'absolute',
      zIndex: '9999',
      bottom: 15,
      left: '-25px',

      '@media (max-width: 349px)': {
        width: '98vw !important'
      }
    }
  }
}))

export default useStyles
